import { get } from 'lodash';

const missingCode = 'ERROR_CV_KEY';

export const converter = {
  convertUnicode(input) {
    if (input === undefined) {
      return '';
    }

    return input.replace(/\\u(\w\w\w\w)/g, (a, b) => {
      const charcode = parseInt(b, 16);
      return String.fromCharCode(charcode);
    });
  },

  convertApaUnicode(apa, key, defaultApa) {
    if (apa === undefined || key === undefined) {
      if (defaultApa !== undefined || defaultApa !== null) return defaultApa;
      return '';
    }
    if (!apa || apa[key] === undefined || apa[key].trim() == '') {
      if (defaultApa === undefined) {
        return '';
      }

      return defaultApa;
    }

    return apa[key].replace(/\\u(\w\w\w\w)/g, (a, b) => {
      const charcode = parseInt(b, 16);
      return String.fromCharCode(charcode);
    });
  },

  convertApa(apa, key) {
    const apaMessage = get(apa, key, missingCode);
    return this.convertUnicode(apaMessage);
  },
};

export const convertAPA = translations => (label, fallback) =>
  converter.convertApaUnicode(translations, label, fallback);
